/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Delta_NewInputs */

const en_directory_launch_delta_new = /** @type {(inputs: Directory_Launch_Delta_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% vs last month`)
};

const zh_directory_launch_delta_new = /** @type {(inputs: Directory_Launch_Delta_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较上月 +20%`)
};

/**
* | output |
* | --- |
* | "20% vs last month" |
*
* @param {Directory_Launch_Delta_NewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_delta_new = /** @type {((inputs?: Directory_Launch_Delta_NewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Delta_NewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_delta_new(inputs)
	return zh_directory_launch_delta_new(inputs)
});
export { directory_launch_delta_new as "directory.launch.delta_new" }